<org-split-screen>
  <router-outlet right-side></router-outlet>
</org-split-screen>
